import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { AuthService } from '../../../../../services';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-user-nav',
  templateUrl: './user-nav.component.html',
  styleUrls: ['./user-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNavComponent implements OnInit {
  user: firebase.User;
  constructor(
    private auth: AuthService,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {}
  subscriptions = new Subscription();
  ngOnInit() {
    this.subscriptions.add(
      this.auth.user.pipe(startWith(this.auth.currentUser)).subscribe(user => {
        this.user = user;
        this.cdRef.detectChanges();
      })
    );
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  login() {
    this.router.navigateByUrl('/login');
  }
  logout() {
    this.auth.logout();
    this.router.navigateByUrl('/home');
  }
}
